module.exports = __webpack_public_path__ + "static/media/LU.c6c7468b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/LU.svg
// module id = 2200
// module chunks = 7